import cx from 'classnames';

import useIsMobile from '../../../hooks/use-is-mobile';
import BPImage from '../../ui/image';
import ImageGroup from '../../ui/image-group';
import VehiclePreview from '../../ui/vehicle-preview';

import classes from './unique-vehicle.module.css';
import ImageSlider from '../../ui/image-group/v2/image-slider';
import IconGallery from '../../ui/icons/gallery';
import NoImage from '../../ui/no-image-placeholder';
import useTranslation from 'next-translate/useTranslation';
import VehicleDetails from './vehicle-details';
import FlowTitleSEO from '../../ui/v2/flow-title';
import PageTitleSEO from '../../ui/v2/typography/page-title';
import ProductPhotos from '../product/v2/photos';

const VehicleHeader = ({
  id,
  uniqueVehicle,
  backgroundImage,
  images,
}: {
  id: TVehicle['sku'];
  uniqueVehicle: TVehicle;
  backgroundImage?: TVehicle['banner_desktop'];
  images: TVehicle['images'];
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <>
      <FlowTitleSEO
        orientation="flex-col lg:flex-row !items-end"
        flowTitleClassName={cx('max-lg:!py-4 lg:!py-12')}
        flowSectionClassName={cx(
          ' grid gap-4 !items-start w-full lg:grid-cols-2'
        )}
        fullWidth={true}
        cols={[
          <div
            key="leading"
            className="flex flex-col gap-4 items-start w-full lg:w-full"
          >
            <div className="flex flex-row gap-4 lg:gap-4 items-start">
              <div
                className={cx(
                  'relative',
                  'aspect-video',
                  'shrink-0',
                  'flex h-[48px] w-[48px]',
                )}
              >
                <BPImage
                  src={
                    uniqueVehicle?.car.brand_alias
                      ? `${process.env.STATIC_PREFIX}/brands/logos/${uniqueVehicle?.car.brand_alias}.svg`
                      : `${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`
                  }
                  layout="fill"
                  objectFit="contain"
                  objectPosition="center"
                  fallbackSrc={`${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`}
                  className={cx('bg-cover mix-blend-multiply')}
                  alt={`${uniqueVehicle?.car.brand_alias || 'car placeholder'
                    } logo`}
                />
              </div>
              <div className="flex flex-col gap-2 items-start">
                <PageTitleSEO
                  isSticky={false}
                  key={'title'}
                  textAlign="left"
                  titleFontClass="font-extrabold text-base lg:text-lg"
                  subtitleFontClass="text-base"
                  contentAlign="flex-row gap-1"
                  title={[
                    ' ',
                    uniqueVehicle?.car.brand_name,
                    uniqueVehicle?.car.model_name,
                    uniqueVehicle?.car.version_name || '',
                    // uniqueVehicle?.reference,
                  ]
                    .join(' ')
                    .replaceAll('|', '')}
                />
                <span className={cx(
                  'text-base',
                  'line-clamp-2'
                )}>{`(${uniqueVehicle?.car.door_nr} ${t('vehicle:doors')})`}</span>
                <h2
                  key="stock"
                  id="h2_sku"
                  className="max-w-[780px] text-center text-base font-extrabold"
                >
                  <span className={cx('inline-block')}>{uniqueVehicle?.sku}</span>
                </h2>
              </div>
            </div>
          </div>
        ]}
        extraContent={[
          <div className='lg:hidden'>
            <div className='relative'>
              <div className='max-lg:container max-lg:mx-auto lg:sticky lg:top-[calc(160px+24px)]'>
                <ProductPhotos list={images} border isPP />
              </div>
            </div>
          </div>,
          <div
            key="vehicle_details"
            className="flex flex-col gap-2 w-full justify-end h-full"
          >
            <VehicleDetails
              plate_date={uniqueVehicle.plate_date}
              vin={uniqueVehicle.vin}
              engine_code={uniqueVehicle.engine_code}
              mileage={uniqueVehicle.mileage}
              mileageCoUk={uniqueVehicle.milageCoUK}
            />
          </div>,
        ]}
      />
      {/* <section className='grid grid-cols-2 gap-6'>
    <section>

    </section>
    <VehicleDetails
      plate_date={uniqueVehicle.plate_date}
      door_nr={uniqueVehicle.car.door_nr}
      vin={uniqueVehicle.vin}
      engine_code={uniqueVehicle.engine_code}
      mileage={uniqueVehicle.mileage}
      mileageCoUk={uniqueVehicle.milageCoUK}
    />
  </section>*/}</>
  );
};

export default VehicleHeader;
